import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import HeroBanner from 'ui/home/HeroBanner';
import ChainIndicators from 'ui/home/indicators/ChainIndicators';
import LatestArbitrumL2Batches from 'ui/home/latestBatches/LatestArbitrumL2Batches';
import LatestZkEvmL2Batches from 'ui/home/latestBatches/LatestZkEvmL2Batches';
import LatestBlocks from 'ui/home/LatestBlocks';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';

const rollupFeature = config.features.rollup;

const SectionDivider = ({ label }: { label: string }) => (
  <Flex alignItems="center" gap={ 3 } mb={ 5 }>
    <Box
      w="4px"
      h="20px"
      borderRadius="full"
      background="linear-gradient(180deg, #1D4ED8 0%, #60A5FA 100%)"
      flexShrink={ 0 }
    />
    <Text
      fontSize="xs"
      fontWeight={ 800 }
      color="blue.800"
      textTransform="uppercase"
      letterSpacing="0.12em"
    >
      { label }
    </Text>
    <Box
      flex={ 1 }
      h="1px"
      background="linear-gradient(90deg, #BFDBFE 0%, transparent 100%)"
    />
  </Flex>
);

const Home = () => {

  const leftWidget = (() => {
    if (rollupFeature.isEnabled && !rollupFeature.homepage.showLatestBlocks) {
      switch (rollupFeature.type) {
        case 'zkEvm':
          return <LatestZkEvmL2Batches/>;
        case 'arbitrum':
          return <LatestArbitrumL2Batches/>;
      }
    }

    return <LatestBlocks/>;
  })();

  return (
    <Box as="main">
      <Box mt={ 6 }>
        <HeroBanner/>
      </Box>

      <Box mt={8} _empty={{ mt: 0 }}>
        <SectionDivider label="Network Stats"/>
        <Flex flexDir={{ base: 'column', lg: 'row' }} columnGap={2} rowGap={1}>
          <Stats/>
        </Flex>
      </Box>

      <Box mt={8}>
        <SectionDivider label="Chain Indicators"/>
        <ChainIndicators/>
      </Box>

      <Box mt={8}>
        <SectionDivider label="Latest Activity"/>
        <Flex direction={{ base: 'column', lg: 'row' }} columnGap={12} rowGap={6}>
          {leftWidget}
          <Box flexGrow={1}>
            <Transactions/>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default Home;
